<div class="error-container">
  <div class="message">
    <h1>Ups!</h1>
    <p>
      No deberías estar aquí. Vuelve al inicio haciendo click en el siguiente
      <a routerLink="/">link</a>
    </p>
  </div>
</div>
